import { Car, MapPin } from "lucide-react";
import { Plate } from "./Plate";
import styles from "./HeaderCard.module.css";

interface HeaderCardProps {
  vehicleLabel?: string | null;
  registration?: string | null;
  branchLabel?: string | null;
  onChangeVehicle?: () => void;
  onChangeBranch?: () => void;
}

/**
 * Persistent context card (journey-2 style): shows the selected vehicle and
 * branch with "Change" affordances. Only renders rows that have data.
 */
export function HeaderCard({
  vehicleLabel,
  registration,
  branchLabel,
  onChangeVehicle,
  onChangeBranch,
}: HeaderCardProps) {
  if (!vehicleLabel && !branchLabel) return null;

  return (
    <aside className={styles.card} aria-label="Your selection">
      <div className={styles.rows}>
        {vehicleLabel && (
          <div className={styles.row}>
            <span className={styles.iconWrap} aria-hidden="true">
              <Car size={16} />
            </span>
            <div className={styles.body}>
              <p className={styles.title}>{vehicleLabel}</p>
              {registration && (
                <Plate registration={registration} size="sm" className={styles.plate} />
              )}
            </div>
            {onChangeVehicle && (
              <button type="button" className={styles.change} onClick={onChangeVehicle}>
                Change
              </button>
            )}
          </div>
        )}

        {branchLabel && (
          <div className={styles.row}>
            <span className={styles.iconWrap} aria-hidden="true">
              <MapPin size={16} />
            </span>
            <div className={styles.body}>
              <p className={styles.subtle}>Location</p>
              <p className={styles.title}>{branchLabel}</p>
            </div>
            {onChangeBranch && (
              <button type="button" className={styles.change} onClick={onChangeBranch}>
                Change
              </button>
            )}
          </div>
        )}
      </div>
    </aside>
  );
}
